/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';

export interface IAdressLabel {
    id: string;
    text: string;
}

/**
 * Address label.
 * @param props - Configuration of the functional component.
 * @returns React functional component.
 */
export const AddressLabelFunctionComponent: React.FC<IAdressLabel> = (props: IAdressLabel) => {
    const { id: itemId, text } = props;

    return (
        <label className='msc-address-form__label' htmlFor={itemId}>
            {text}
        </label>
    );
};

export default AddressLabelFunctionComponent;
